import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { OrderItem } from '../../../models/order-item.model';
import { TranslateService } from '../../../services/translate.service';
import { SKU } from '../../../models/sku.model';
import { OrderItemSku } from '../../../models/order-item-sku.model';
import { ProductService } from '../../../services/product.service';

interface Variation {
    label: string;
    quantity: number;
    price: number;
    originalPrice?: number;
    totalCost: number
}

@Component({
    selector: 'app-order-item-variations',
    templateUrl : './order-item-variations.component.html',
    styleUrls: ['./order-item-variations.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush

})
export class  OrderItemVariationsComponent implements OnInit {

    @Input() orderItem: OrderItem;

    variations: Variation[] = [];

    constructor(private translateService: TranslateService) {}


    ngOnInit(): void {
        this.variations = this.getVariations( this.orderItem);
    }


    getVariations(orderItem: OrderItem): Variation[]  {
        if (!orderItem.product.hasVariations) {
            return [];
        }

        const skus: SKU[] = orderItem.product.skus;

        return orderItem.skus.map( (orderSKU: OrderItemSku) => {

            const productSKU = skus.find( sku => sku.id === orderSKU.sku_id);

            return  {
                label: this.getVariationLabel(productSKU),
                quantity: orderSKU.quantity,
                price: this.getPriceTier(productSKU, orderSKU.quantity),
                originalPrice: productSKU.originalPrice,
                totalCost: ProductService.computeDiscountPrice(orderSKU.price, orderItem.product, orderItem.hasTrimesterBudget)
            };

        })

    }


    getVariationLabel(sku: SKU): string {
        const result: string[] = sku.attributes.sort( (a, b) => {
            return (a.label > b.label) ? 1 : ((b.label > a.label) ? -1 : 0);
        }).map( attribute => {
            const label = this.translateService.translate(attribute.label);

            return `${label}: ${attribute.options[0].label}`;
        });

        return result.join(', ');
    }


    getPriceTier(productSKU: SKU, quantity): number {
        for (const [key, index] of Object.entries(productSKU.prices)) {
            if (quantity < key) {
                return Number(index);
            }
        }
    }


}
